import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { object } from 'prop-types'
import { withTheme } from 'emotion-theming'
import { SearchContext } from './SearchProvider'

// components
import AdditionalResources from './AdditionalResources/index'
import SearchForm from './SearchForm'
import SearchFilterSort from './SearchFilterSort'
import SearchResultsCount from './SearchResultsCount'
import LoadMoreButton from 'components/LoadMoreButton'
import { PulseBarPreloader, ResultsList } from '@jelly/components'
import { Tabs } from '@jelly/templates'

const LoadMoreContainer = styled.div`
	padding-top: 2rem;
	width: 100%;
`

// styled components
const SearchWrap = styled.div`
	color: ${({ theme }) => theme.colors.text};
	padding: 1rem;

	${({ theme }) => theme.MQ.M} {
		flex-direction: row;
		margin: auto;
		padding: 40px;
		max-width: 1200px;
	}
`

const SearchFormContainer = styled.div`
	margin: 0 auto;
	width: 100%;
`

const SearchTabContainer = styled.div`
	margin-top: 20px;
	position: relative;
	width: 100%;
`
const ToolBar = styled.div`
	display: inline-block;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: space-between;
	padding: 20px 0;
	width: 100%;

	${({ theme }) => theme.MQ.S} {
		display: flex;
		flex-direction: row;
	}

	${({ theme }) => theme.MQ.L} {
		padding: 30px 0;
		width: 70%;
	}
`
const SearchResultsBody = styled.div`
	display: block;

	${({ theme }) => theme.MQ.L} {
		display: flex;
	}
`
const ResultsContainer = styled.div`
	flex-basis: 100%;

	em {
		color: steelblue;
		background: rgba(139, 210, 230, 0.2);
		padding: 0 0.2em;
		font-weight: 700;
		font-style: normal;
	}

	${({ theme }) => theme.MQ.L} {
		flex-basis: 70%;
		margin-right: 30px;
		max-width: 70%;
	}
`

const LoadingContainer = styled.div`
	height: 100%;
	min-height: 100vh;
	padding-bottom: 0;
	text-align: center;
`

const AdditionalResourcesWrap = styled.div`
	display: block;

	${({ theme }) => theme.MQ.L} {
		display: inline-block;
		flex-basis: 30%;
		min-width: 280px;
		max-width: calc(30% - 30px);
	}
`

SearchBody.propTypes = {
	theme: object.isRequired,
}

const ARTICLE = 'article'

/**
 * This is the Search Page Body display
 * Everything between the header and footer
 *
 * Uses the reusable Tab Component that is React Router friendly
 */
function SearchBody({ theme }) {
	const {
		businessListings,
		currentTab,
		handleLoadMoreResults,
		isLoadingMoreResults,
		isLoadingPanelVisible,
		results,
		searchTerm,
		searchTabs,
	} = useContext(SearchContext)
	const tabResults = results[searchTerm] && results[searchTerm][currentTab] && results[searchTerm][currentTab].data
	return (
		<SearchWrap>
			<SearchFormContainer>
				<SearchForm />
			</SearchFormContainer>
			<SearchTabContainer>
				<Tabs areTabsDisabled={isLoadingPanelVisible} currentTab={currentTab} tabData={searchTabs} />
				<ToolBar>
					<SearchFilterSort />
					{!isLoadingPanelVisible && <SearchResultsCount />}
				</ToolBar>
				<SearchResultsBody>
					<ResultsContainer>
						{isLoadingPanelVisible ? (
							<LoadingContainer>
								<PulseBarPreloader fill={theme.colors.orange} />
							</LoadingContainer>
						) : (
							<ResultsList
								results={tabResults}
								searchTerm={searchTerm}
								showContentDescription={currentTab !== ARTICLE}
							/>
						)}
						{results[searchTerm] &&
							results[searchTerm][currentTab] &&
							results[searchTerm][currentTab].loadMore &&
							tabResults.length > 0 && (
								<LoadMoreContainer>
									<LoadMoreButton
										handleLoadMoreResults={handleLoadMoreResults}
										isLoadingMoreResults={isLoadingMoreResults}
									/>
								</LoadMoreContainer>
							)}
					</ResultsContainer>
					{businessListings[searchTerm] && businessListings[searchTerm].length > 0 && (
						<AdditionalResourcesWrap>
							<AdditionalResources />
						</AdditionalResourcesWrap>
					)}
				</SearchResultsBody>
			</SearchTabContainer>
		</SearchWrap>
	)
}

export default withTheme(SearchBody)
